<!-- =========================
     FULLSCREEN BACKGROUND
========================= -->
<div class="min-vh-100 position-relative overflow-hidden">

  <img
    src="https://empirewebvideos.s3.us-east-1.amazonaws.com/Probabase_bolide/union.png"
    class="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
    alt="Hero image"
  />

  <div class="position-absolute top-0 start-0 w-100 h-100 bg-dark opacity-50"></div>

  <div class="container position-relative z-1 min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row justify-content-center align-items-center w-100">

      <!-- =========================
           PASSWORD RESET COMPLETE
      =========================== -->
      <div class="glass-card p-4 p-md-5 rounded-4 shadow-sm col-12 col-sm-8 col-md-6 col-lg-5 col-xl-5 mx-auto">

        <!-- Heading -->
        <h3 class="fw-bold mb-1 text-center text-white">
          Password Reset Complete
        </h3>

        <p class="text-center text-white-50 mb-4 text-sm">
          Your password has been successfully reset.  
          You can now log in using your new credentials.
        </p>

        <!-- SUCCESS MESSAGE -->
        <div 
          v-if="success_message" 
          class="alert alert-success alert-dismissible fade show rounded-3"
          role="alert"
        >
          {{ success_message }}
          <button 
            type="button" 
            class="btn-close"
            @click="success_message = ''"
          ></button>
        </div>

        <!-- Back To Login -->
        <div class="text-center">
          <router-link 
            to="/login" 
            class="btn btn-primary w-100 rounded-3 fw-light text-xs"
          >
            Go to Login
          </router-link>
        </div>

      </div>

    </div>
  </div>
</div>
